import { render } from "./ProfileHeader.vue?vue&type=template&id=1fecc55e"
import script from "./ProfileHeader.vue?vue&type=script&lang=ts"
export * from "./ProfileHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script